import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'
import { ShipperGuideClient } from 'core/infra/http/ShipperGuideClient'

import { TenderRepository } from '../infra/TenderRepository'

export type RejectTenderFactoryDependencies = {
  tenderRepository: TenderRepository
}

export type RejectTenderParams = {
  id: string
  rejectReason: string
}

export function rejectTenderFactory({ tenderRepository }: RejectTenderFactoryDependencies) {
  return function rejectTenderImpl(params: RejectTenderParams, config?: { signal?: AbortSignal }) {
    return tenderRepository.rejectTender(params, config)
  }
}

export function rejectTender(params: RejectTenderParams, config?: { signal?: AbortSignal }) {
  const httpClient = new HttpClient(API_URL)
  const shipperGuideHttpClient = new ShipperGuideClient()
  const tenderRepository = new TenderRepository({ httpClient, shipperGuideHttpClient })
  const newRejectTender = rejectTenderFactory({ tenderRepository })
  return newRejectTender(params, config)
}
